import emojiRegex from "emoji-regex"

export const noNumberRegex = /^([^0-9]*)$/

export const testForEmojisTestExplaination =
  "Testing that string does not include emoji"

export const testForEmojis = (val?: string): boolean => {
  if (!val) {
    // If no value we pass test and let required handle
    return true
  }
  // returns true if emoji is found, and we need to return false to fail the yup validation test
  return !emojiRegex().test(val)
}
